import jq from 'jquery';

function init() {
  jq('.important-announcement-close').click(function () {
    // check if it's not the update-browser-banner or ppp-draft-banner
    const warningBanner = jq(this).hasClass('js-warning-close');
    if (warningBanner === false) {
      jq(this).closest('.important-announcement').slideUp();
    }
  });
}

export default {
  init,
};
